/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PayerContractRules } from './PayerContractRules';
import {
    PayerContractRulesFromJSON,
    PayerContractRulesFromJSONTyped,
    PayerContractRulesToJSON,
    PayerContractRulesToJSONTyped,
} from './PayerContractRules';

/**
 * 
 * @export
 * @interface GetPayerContractRules200Response
 */
export interface GetPayerContractRules200Response {
    /**
     * 
     */
    data?: PayerContractRules;
}

/**
 * Check if a given object implements the GetPayerContractRules200Response interface.
 */
export function instanceOfGetPayerContractRules200Response(value: object): value is GetPayerContractRules200Response {
    return true;
}

export function GetPayerContractRules200ResponseFromJSON(json: any): GetPayerContractRules200Response {
    return GetPayerContractRules200ResponseFromJSONTyped(json, false);
}

export function GetPayerContractRules200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPayerContractRules200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PayerContractRulesFromJSON(json['data']),
    };
}

export function GetPayerContractRules200ResponseToJSON(json: any): GetPayerContractRules200Response {
    return GetPayerContractRules200ResponseToJSONTyped(json, false);
}

export function GetPayerContractRules200ResponseToJSONTyped(value?: GetPayerContractRules200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PayerContractRulesToJSON(value['data']),
    };
}

